export const SET_ANEXOS = 'upload.SET_ANEXOS';
export const SET_ANEXOS_SAGA = 'upload.SET_ANEXOS_SAGA';
export const SET_ANEXOS_CUSTOMIZADOS = 'upload.SET_ANEXOS_CUSTOMIZADOS';
export const SET_ANEXOS_CUSTOMIZADOS_SAGA = 'upload.SET_ANEXOS_CUSTOMIZADOS_SAGA';
export const CHANGE_ANEXO = 'upload.CHANGE_ANEXO';
export const DELETE_ANEXO = 'upload.DELETE_ANEXO';
export const ADD_ANEXO_CUSTOMIZADO = 'upload.ADD_ANEXO_CUSTOMIZADO';
export const CHANGE_TEXT_ANEXO = 'upload.CHANGE_TEXT_ANEXO';
export const RESET = 'upload.RESET_ANEXOS';
